import type { ModelBaseNodeData } from '@/types/nodes/model';
import type { Node } from '@/types/node';

export interface RunNodeOptions {
  /**
   * Params merged into a node's payload for this run only, keyed by node id. They are never saved
   * on the node, so the next ordinary run does not carry them.
   */
  paramOverrides?: Record<string, Record<string, unknown>>;
}

/** Merges each node's one-off `paramOverrides` into its payload params. */
export function applyParamOverrides(nodes: Node[], paramOverrides: RunNodeOptions['paramOverrides']): Node[] {
  if (!paramOverrides) {
    return nodes;
  }
  return nodes.map((node) => {
    const overrides = paramOverrides[node.id];
    if (!overrides) {
      return node;
    }
    const data = node.data as ModelBaseNodeData;
    return { ...node, data: { ...data, params: { ...data.params, ...overrides } } };
  });
}
